import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from '@services/user.service';

@Component({
    selector: 'app-pay-invoice',
    templateUrl: './pay-invoice.component.html',
    styleUrls: ['./pay-invoice.component.scss']
})
export class PayInvoiceComponent {

    file: File = null;
    fileName = '';
    loading = false;
    error = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { remaining: number },
        private userService: UserService,
        public dialogRef: MatDialogRef<PayInvoiceComponent>,
    ) {
    }

    onFileSelected(event: any) {
        const f: File = event.target.files && event.target.files[0];
        event.target.value = '';
        if (!f) {
            return;
        }
        if (f.type !== 'application/pdf' && !f.name.toLowerCase().endsWith('.pdf')) {
            this.error = 'Le fichier doit être un PDF.';
            this.file = null;
            this.fileName = '';
            return;
        }
        this.error = '';
        this.file = f;
        this.fileName = f.name;
    }

    submit() {
        if (!this.file || this.loading) {
            return;
        }
        this.loading = true;
        this.userService.payFilleul(this.file).subscribe(res => {
            this.loading = false;
            this.dialogRef.close(res);
        }, error => {
            this.loading = false;
            this.error = error;
        });
    }

    close() {
        this.dialogRef.close(false);
    }
}
